import React, { Component } from "react";
import { connect } from 'react-redux';
import htmlTagValidator from 'html-tag-validator'
import renderHTML from 'react-render-html';
import Swal from 'sweetalert2'
import { NavigationHeader } from "../../layout/components/navigationheader/NavigationHeader";
import { Card, Button, Row, Col, Form } from 'react-bootstrap';
import { updateRequestShortcode, USER_STUDIO_WALL } from '../../../../../../../actions/sceneActions'
import { SHORT_CODE_SUCCESS_SAVE, SUCCESS_TEXT } from '../../../app/messageText'
import { customClass } from '../../../../../../../utils'

class UpdateShortCode extends Component {
    state = {
        shortcode: null,
        shortcodePreview: null,
        buttonDis:false,
        loader:false
    }
    componentDidMount() {
        const { match, scenes, history } = this.props;
        if (scenes.updateSceneData && Object.keys(scenes.updateSceneData).length > 0) {
            this.setState({ shortcode: scenes.updateSceneData.content, shortcodePreview: scenes.updateSceneData.content })
        }
        else history(`/studio/${match.params.wallId}`)
    }
    onTextShortCode = event => {  
        this.setState({ shortcode: event.target.value }, () => this.htmlRender())
    }
    onSaveShortCode = event => {
        const { params } = this.props.match;
        const { shortcode } = this.state;
        this.setState({loader:true, buttonDis:true})
        this.props.updateRequestShortcode(params.contentMixId, this.props.scenes.updateSceneData.id, shortcode, this.onSaveCallBack)
    }
    onBack = event => {
        const { params } = this.props.match;
        Swal.fire({
            title: "Are you sure?",
            text: "Your changes have not been saved. Do you want to save before you leave the page?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Save",
            cancelButtonText: "Discard Changes",
            reverseButtons: true,
            customClass: customClass
        }).then((result) => {
            if (result.value) {
                const { params } = this.props.match;
                const { shortcode } = this.state;
                this.props.updateRequestShortcode(params.contentMixId, this.props.scenes.updateSceneData.id, shortcode, this.onSaveCallBack)
            } else if (result.dismiss === "cancel") {
                this.props.history(`/studio/${params.wallId}`)

            }
        });
    }
    onSaveCallBack = () => {
        const { params } = this.props.match;
        this.props.USER_STUDIO_WALL(params.wallId);
        Swal.fire({
            title: SUCCESS_TEXT,
            text: SHORT_CODE_SUCCESS_SAVE,
            type: "success",
            icon: 'success',
            showConfirmButton: false,
            timer: 3000
        }
        ).then((result) => {
            this.setState({loader:false, buttonDis:false})
            this.props.history(`/studio/${params.wallId}`)
        })

    }
    htmlRender = () => {
        const { shortcode } = this.state;
        try {
            htmlTagValidator(shortcode, (err, ast) => {
                if (err) {
                    this.setState({ shortcodePreview: null })
                    // throw err;
                } else {
                    this.setState({ shortcodePreview: shortcode })
                }
            });

        }
        catch (ex) {
            return ""
        }
    }

    render() {
        const { match } = this.props;
        const { shortcode, buttonDis, loader } = this.state;
        return (<div>
            <NavigationHeader name="Short Code" backToNavigation={`/studio/${match.params.wallId}`} />
            <div className="container-fluid subheader_content">
                <Card className="select_wall mb-3 rounded-0 border-0">
                    <Card.Body className="p-0">
                        <Row>
                            <Col lg={4} className="border-right-lg">
                                <Card className="border-0 rounded-0">
                                    <Card.Body className="p-4 card_height">
                                        <Form>
                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Label>Enter Shortcode</Form.Label>
                                                <Form.Control as="textarea" rows={5} className="text-url-update" onChange={this.onTextShortCode} value={shortcode} placeholder="<div>www.taggbox.com</div> " />
                                            </Form.Group>

                                        </Form>
                                    </Card.Body>
                                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                                        <button className="btn btn-outline-dark mr-4 btn-min-w" onClick={this.onBack}><span className="position-relative">Back</span></button>
                                        <Button disabled={ buttonDis }  variant="primary" className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`} onClick={this.onSaveShortCode}>Save</Button>
                                    </Card.Footer>
                                </Card>

                            </Col>
                            <Col lg={8} className="d-flex align-items-center justify-content-center">
                                <Card className="border-0 card w-100">
                                    <Card.Body className="border-0">
                                        <div className="wall_view">
                                            <div className="wall_view_wrapper">
                                                {
                                                    shortcode && renderHTML(shortcode)
                                                }
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>
            </div>

        </div>);
    }
}

const mapStateToProps = state => {
    return {
        scenes: state.scene,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        updateRequestShortcode: (contentMixId, contentId, shortCode, callBack) => dispatch(updateRequestShortcode(contentMixId, contentId, shortCode, callBack)),
        USER_STUDIO_WALL: (wallID) => dispatch(USER_STUDIO_WALL(wallID))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateShortCode);